<template>
    <transition name="el-fade-in-linear">
    <div v-show="transitionshow">       
      	
      	<!--------------- 新增采购退货界面 --------------->
    		<el-form :inline="true" class="backborder1 demo-form-inline" ref="search"  size="small">
    			<el-form-item>
		    		<el-select v-model="create.applyid" clearable filterable remote reserve-keyword placeholder="请选择供应商" @change="changesupplier">
				        <el-option v-for="(item,index) in supplierlists" :key="index" :label="item.apply_name" :value="item.id"></el-option>
				    </el-select> 
		    	</el-form-item>
    			<el-form-item>
    				<el-select v-model="create.clerkid" clearable filterable placeholder="请选销售员" style="width:100%">
						<el-option v-for="(item,index) in sellerLists" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
    			</el-form-item>
		        <el-form-item>
		            <el-input placeholder="请输入条形码" v-model="productquery.key">
		          	    <template slot="prepend">查找</template>
		          	    <el-button slot="append" icon="el-icon-search" @click="addDialogShow"></el-button>
		            </el-input>
		        </el-form-item>
		        <el-form-item>
		        	<el-button type="warning" @click="addDialogmore">批量添加商品</el-button>
		        </el-form-item>
				<el-form-item>
					<el-badge :value="create.goods.length > 0 ? create.goods.length : ''" class="item">
		        	<el-button type="" @click="clearall">清空商品</el-button>
					</el-badge>
		        </el-form-item>
		    </el-form>


			<div class="backborder1" style="margin-top:10px;padding-bottom:10px;position:relative;overflow:hidden;">
				<div class="cz-sell-base-lists-infos-out">
					<div class="cz-sell-base-lists-infos">
						<span class="cz-sell-base-lists-infos-title">单据编号</span>
						<div class="cz-sell-base-lists-infos-content">
							<el-input v-model="create.documents" placeholder="单据编号" :disabled="true"></el-input>
						</div>
					</div>
					<div class="cz-sell-base-lists-infos">
						<span class="cz-sell-base-lists-infos-title">付款账号</span>
						<div class="cz-sell-base-lists-infos-content">
							<el-select v-model="create.account" placeholder="未付款">
							    <el-option v-for="(item,index) in accountLists" :key="index" label="未付款" value="0" v-if="item.id==0"></el-option>
							    <el-option v-for="(item,index) in accountLists" :key="index" :label="item.name" :value="item.id" v-if="item.id > 0"></el-option>
							</el-select>
						</div>
					</div>
					<div class="cz-sell-base-lists-infos">
						<span class="cz-sell-base-lists-infos-title">退货备注</span>
						<div class="cz-sell-base-lists-infos-content">
							<el-input v-model="create.note" placeholder="退货备注"></el-input>
						</div>
					</div>
				</div>

				<div class="cz-sell-base-lists-infos-goods" style="margin-top:10px">
			    <el-table :data="create.goods" :border="true" show-summary :summary-method="totalRule" style="width: 100%" v-loading="goodsListLoading">    		    	
		        	<el-table-column label="商品名称" align="left"  min-width="250">
						<template slot-scope="props">
							<div style="font-size:13px;line-height:23px;">{{props.row.name}}</div>
							<div style="font-size:12px;line-height:23px;color:#999999">编号：{{props.row.number}}</div>
						</template>
					</el-table-column>

					<el-table-column label="采购单号" align="center" min-width="110">
						<template slot-scope="props">
							<div style="font-size:13px;line-height:23px;">{{props.row.purchasedocuments}}</div>
						</template>
					</el-table-column>
					<el-table-column label="入库单号" align="center" min-width="110">
						<template slot-scope="props">
							<div style="font-size:13px;line-height:23px;">{{props.row.documents}}</div>
						</template>
					</el-table-column>
					<el-table-column label="成本价" align="center" min-width="110">
		        		<template slot-scope="props">
		        			<el-input size="small" v-model="props.row.buy"  @blur="setgoodsbuy(props.row)"></el-input>
		        		</template>
		        	</el-table-column>
					<el-table-column label="数量" align="center" min-width="110">
		        		<template slot-scope="props">
		        			<el-input size="small" v-model="props.row.basenum"  @blur="setgoodsnum(props.row)"></el-input>
		        		</template>
		        	</el-table-column>
					<el-table-column label="成本小计" align="center" min-width="110">
						<template slot-scope="props">
							<div style="font-size:13px;line-height:23px;">{{props.row.total|CFMprice}}</div>
						</template>
					</el-table-column>
					<el-table-column label="仓库" align="center" min-width="110">
						<template slot-scope="props">
							<div style="font-size:13px;line-height:23px;">{{props.row.warehousename}}</div>
						</template>
					</el-table-column>
					<el-table-column label="货位" align="center" min-width="180" v-if="goodsLocationStatus">
						<template slot-scope="props">
							<div style="font-size:13px;line-height:23px;">{{props.row.storage_location_code}}</div>
						</template>
					</el-table-column>
					<el-table-column label="批次号" align="center" min-width="180" v-if="batchStatus">
						<template slot-scope="props">
							<div style="font-size:13px;line-height:23px;">{{props.row.batch_sn}}</div>
						</template>
					</el-table-column>
					<el-table-column label="生产日期" align="center" min-width="160" v-if="batchStatus">
						<template slot-scope="props">
							<div style="font-size:13px;line-height:23px;">{{props.row.start_date || '/'}}</div>
						</template>
					</el-table-column>
					<el-table-column label="有效期" align="center" min-width="160" v-if="batchStatus">
						<template slot-scope="props">
							<div v-if="props.row.realvalidity != '0'" style="font-size:13px;line-height:23px;">{{props.row.realvalidity}}{{ validityunitTemp[props.row.validityunit] }}</div>
							<div v-else>/</div>
						</template>
					</el-table-column>
					<el-table-column label="到期日期" align="center" min-width="160" v-if="batchStatus">
						<template slot-scope="props">
							<div style="font-size:13px;line-height:23px;">{{props.row.end_date || '/'}}</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" min-width="100" align="center" fixed="right">
		        		<template slot-scope="props">
		        			<el-button type="" size="small" round  @click="delgoods(props.row)">删除</el-button>
		        		</template>
		        	</el-table-column>       
	      		</el-table>
      			</div>

				<div class="cz-sell-order-stat">
				<div class="cz-sell-order-stat-totals" style="width:calc(100% - 10% - 40px - 40px - 1px)">
					<div style="float:left;width:100%">
						<div class="cz-sell-order-stat-totals-name" style="width:calc(33% - 30px) !important">
							<span class="cz-sell-order-stat-totals-name-title">订单金额：￥</span>
							<span class="cz-sell-order-stat-totals-name-content">{{create.total|CFMprice}}</span>
						</div>
						<div class="cz-sell-order-stat-totals-name" style="width:calc(33% - 30px) !important">
							<span class="cz-sell-order-stat-totals-name-title">优惠金额：￥</span>
							<span class="cz-sell-order-stat-totals-name-content">{{create.derate|CFMprice}}</span>
						</div>
						<div class="cz-sell-order-stat-totals-name" style="width:calc(33% - 30px) !important">
							<span class="cz-sell-order-stat-totals-name-title">应付金额：￥</span>
							<span class="cz-sell-order-stat-totals-name-content">{{create.real|CFMprice}}</span>
						</div>
					</div>
					<div class="cz-sell-order-stat-handles" style="width:45%">
						<el-button type="warning" :loading="addorderLoading" @click="createSave" size="small">保存</el-button>
						<el-button type="warning" :loading="verifyorderLoading" @click="verifySave" size="small">确认审核</el-button>
						<el-button type="warning" :loading="verifyandprintorderLoading" @click="verifyandprintSave" size="small">确认审核并打印</el-button>
						<el-button type="" :loading="delorderLoading" v-if="create.id > 0 && create.status==0" @click="delSave" size="small">删除订单</el-button>
					</div>
				</div>
				</div>
				
			</div>
    	
    	<!----------批量添加产品----------->
  		<el-dialog title="添加产品" :visible.sync="addproductDialog" width="70%" top="1vh">
		  	
      		<el-form :inline="true" class="demo-form-inline" size="small" style="margin-top:15px">
	          	<el-form-item>
		            <el-select v-model="productquery.brandid" filterable clearable placeholder="按品牌"  @change="selectbrand">
		              <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
		              	  <span style="float: left">{{item.name}}</span>
      				      <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
		              </el-option>
		            </el-select>
	          	</el-form-item>
	          	<el-form-item ref="productquery" :model="productquery">
	            	<el-input placeholder="商品名称 / 条形码 / 编号 / 拼音码" clearable v-model="productquery.key" @keyup.enter.native="getProductList" @change="productselect=true" @input="changesearchkey"></el-input>
	          	</el-form-item>
	          	<el-form-item>
	            	<el-button type="warning" icon="el-icon-search" @click="getProductList">查询</el-button>
	          	</el-form-item>
				<el-form-item>
	            	<el-button type="" @click="cleargoods">清空勾选</el-button>
	          	</el-form-item>
        	</el-form>        	
        	
      		<!------------------------search end---------------------->
	      	<el-table ref="multipleTable" :data="productlists" style="width: 100%" v-loading="addListLoading" tooltip-effect="dark" @row-click="rowclick" @select="handleSelectsingle"  @select-all="handleSelectall"  >
	            <el-table-column type="selection" width="50"></el-table-column>
				<el-table-column prop="name" label="商品" min-width="250">
					<template slot-scope="scope">
						<div style="font-size:13px;line-height:23px;float:left;width:100%">{{scope.row.name}}</div>
						<div style="font-size:12px;line-height:23px;float:left;width:100%;color:#999999">编号：{{scope.row.number}}</div>
					</template>
				</el-table-column>
				<el-table-column label="关联采购单" min-width="140" align="center">
					<template slot-scope="scope">
						<div style="font-size:13px">{{scope.row.documents}}</div>
					</template>
				</el-table-column>
				<el-table-column label="关联入库单" min-width="140" align="center">
					<template slot-scope="scope">
						<div style="font-size:13px">{{scope.row.storagedocuments}}</div>
					</template>
				</el-table-column>
	            <el-table-column label="可退数量" min-width="140" align="center">
					<template slot-scope="scope">
						<div style="font-size:13px">{{scope.row.inventory}} {{scope.row.unit}}</div>
					</template>
				</el-table-column>
				<el-table-column label="退货数量" min-width="140" align="center">
					<template slot-scope="scope">
						<el-input type="text" round v-model="scope.row.refundnums" size="small" @focus="focusrefundnums" @blur="blurrefunnums(scope.row)">
						<template slot="append">{{scope.row.unit}}</template>
						</el-input>
					</template>
				</el-table-column>
	      	</el-table>
      		<div class="block">      		
            <!--分页begin-->
            <el-pagination
	            @size-change="productPageSizeChange"
	            @current-change="productPageCurrentChange"
	            :current-page="productquery.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="productquery.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="total_product_rows">
            </el-pagination>
            <!--分页end-->
      		</div>
	        <div slot="footer" class="dialog-footer">
	            <el-button size="small" @click="addproductDialog = false">取 消</el-button>
	            <el-button size="small" type="primary" :loading="addProductLoading" @click="addSave">确认添加</el-button>
	        </div>	        
  		</el-dialog>
  		
  		<!---------------------------获取单位--------------------------->
	    <el-dialog title="选择单位" :visible.sync="unitDialog">
	        <el-table :data="unitlists.lists" style="width: 100%" v-loading="unitListLoading">
		        <el-table-column label="单位" prop="unit"></el-table-column>
		        <el-table-column label="进货价" prop="buy"></el-table-column>
		        <el-table-column label="选择" width="80">
		            <template slot-scope="scope">
		            	<el-button type="success" size="mini" icon="el-icon-check" circle  @click="changeUnitSave(scope.row)"></el-button>
		            </template>
		        </el-table-column>
	        </el-table>
	    </el-dialog>
	    
	    <!---------------------------修改仓库--------------------------->
    	<el-dialog title="选择仓库" :visible.sync="wareDialog" width="40%">
      		<el-table :data="wareHouseLists" style="width: 100%" v-loading="wareListLoading">
        		<el-table-column label="仓库名称" prop="name"></el-table-column>
        		<el-table-column label="选择" width="80">
          			<template slot-scope="scope">
            			<el-button type="success" size="small" circle icon="el-icon-check"  @click="changewarehouseSave(scope.row)"></el-button>
          			</template>
        		</el-table-column>
      		</el-table>
    	</el-dialog>
    	
    	
    	<!----------- 订单打印页面 ----------------> 
	    <el-dialog title="确认打印" :visible.sync="printerDialog" width="80%" top="5vh">
  	  		<div style="width:100%;text-align:right">每页展示  <input type="text" v-model="rollpage"  v-on:blur="changepagevlaue()"  style="border-radius:5px;border:1px solid rgb(192, 196, 204);background-color:#fff;color:#606266;width:25px;height:30px;line-height:40px;padding:0 15px;margin-bottom:20px"/>  条</div>	
      			<div id="printContent" v-loading="printLoading">
          	  		<div v-for="(item,index) in printlists" :key="index">
          	  			<span style="float:right">{{item.pagesize}}</span>
	      	  			<DIV style="font-size:18px;padding-bottom:2px;margin-bottom:0" align="center" ><STRONG>采购退货单</STRONG></DIV>        
	      	  			<ul class="titlelists">
					  	    <!--<li >供货商名：{{item.applyname}}</li>-->
						    <li >单据编号：{{item.documents}}</li>
						    <!--<li >联系电话：{{item.phone}}</li>-->
						    <!--<li >采购人员：{{item.clerkname}}</li>-->
						    <li >出库备注：{{item.note}}</li>
						    <!--<li style="width:100%">联系地址：{{item.address}}</li>-->
				  	  	</ul>
	      			
	          			<TABLE border=1 cellSpacing=0 cellPadding=1 width="100%" style="border-collapse:collapse;font-size:15px" bordercolor="#333333">
			 			    <TR class="contactcontent">
			 			    	<TD><DIV align=center><b>序号</b></DIV></TD>
				            	<TD ><DIV align=center><b>编号</b></DIV></TD>
				                <TD ><DIV align=center><b>商品</b></DIV></TD>
				                <TD ><DIV align=center><b>规格</b></DIV></TD>
				                <TD ><DIV align=center><b>单位</b></DIV></TD>
				                <TD ><DIV align=center><b>单价</b></DIV></TD>
				                <TD ><DIV align=center><b>数量</b></DIV></TD>
				                <TD ><DIV align=center><b>小计</b></DIV></TD>
			                </TR>
				            <tr v-for="(tt,ii) in item.goods" :key="ii"  class="contactcontent">
				            	<TD v-text="tt.gsort" align="center"></TD>
					            <TD v-text="tt.number" align="center"></TD>
					            <TD v-text="tt.name" style="padding-left:1%" ></TD>
					            <TD v-text="tt.spec" style="padding-left:1%" ></TD>
					            <TD v-text="tt.unit" align="center" ></TD>
					            <TD v-text="tt.buy" align="center" ></TD>
					            <TD v-text="tt.num" align="center" ></TD>
					            <TD v-text="tt.total" align="center" ></TD>
				            </tr>
				            <tr v-if="index+1==printlists.length" class="contactcontent">
					            <TD align="center">合计</TD>
					            <TD style="padding-left:1%" ></TD>
					            <TD style="padding-left:1%" ></TD>
					            <TD style="padding-left:1%" ></TD>
					            <TD align="center" ></TD>
					            <TD align="center" ></TD>
					            <TD align="center" >{{item.goodscount}}</TD>
					            <TD align="center" >{{item.total}}</TD>
				            </tr>
	      	  			</table>
	          			<TABLE border=0 cellSpacing=0 cellPadding=0 width="100%">
		          			<TBODY>
			          			<TR class="top1">
			          				<TD ><span>录单日期：{{item.inputtime}}</span></TD>
				          			<TD ><span>审核人：{{item.verifyername}}</span></TD>
				          			<TD ><span>操作人：{{item.managername}}</span></TD>
			          			</TR>
			          			<TR class="top1">				          			
				          			<TD ><span>合计金额：{{item.total}} 元</span></TD>
				          			<TD ><span>优惠金额：{{item.derate}} 元</span></TD>				          			
			          				<TD ><span>实付金额：{{item.real}} 元</span></TD>
			          			</TR>
		          			</TBODY>
	          			</TABLE>
	          			<div class="pageBreak"></div>
          			</div>          
	  			</div>
		      	<div slot="footer" class="dialog-footer">
			        <el-button @click="printerDialog = false" size="small">取 消</el-button>			        
			        <el-button type="primary" icon="el-icon-printer" @click="createnoSave" :loading="printorderLoading" size="small">打印订单</el-button>
		      	</div>
  		</el-dialog>
	    <!----------- 订单打印页面 ---------------->
    	
    	
    </div>
    </transition>      
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Purcharserefund/index",
      transitionshow:true,
	  validityunitTemp: {
		1: '日',
		2: '月',
		3: '年'
	  },
      actionauth:[],
      order:{
      	act:'lists',
		token:this.$cookies.get('token'),
		date:'',
		key:'',
		status:'',
		account:'',
		p:1,
		rollpage:10
      },
      orderisselect:false,
      wareHouseLists:[],
      statuslists:[
      	{id:1,name:'未审核'},
      	{id:2,name:'已审核'},
      	{id:3,name:'已完成'},
      	{id:4,name:'已撤销'},
      ],
      accountLists:[],
      orderlists:[],
      orderLoading:false,
      order_total_rows:0,
      addDialog:false,
      create:{
      	  act:'add',
          token:this.$cookies.get('token'),
      	  id:0,
      	  applyid:'',
      	  clerkid:'',
      	  documents:'',
      	  account:'',
      	  total:0.00,
      	  real:0.00,
      	  derate:0.00,
      	  note:'',
      	  goods:[],
      },
      productquery: {
      	  act:'inventory_news',
          token:this.$cookies.get('token'),
      	  key:'',
      	  clerkid:'',
      	  applyid:'',
      	  brandid:'',
      	  catid:[],
      	  p:1,
      	  rollpage:10,  
      },
      sellerLists:[],
      supplierlists:[],
      addproductDialog:false,
      brandlists:[],
      categorylist:[],
      productlists:[],
      addListLoading:false,
      total_product_rows:0,
      addProductLoading:false,
      productselect:false,
      multipleSelection:[],      
	  nowtime:0,
	  timeoutflag:true,
      isopenselect:true,
      goodsListLoading:false,
      unitDialog:false,
      unitListLoading:false,
      unitlists:{
      	tempid:'',
      	lists:[]
      },
      warehouselists:{
      	tempid:'',
      	lists:[]
      },
      wareDialog:false,
      wareListLoading:false,
      addorderLoading:false,
      verifyorderLoading:false,
      verifyandprintorderLoading:false,
      delorderLoading:false,
      printLoading:false,
      printerDialog:false,
      printlists:[],
      rollpage:10,
      printorderLoading:false,
      cannelLoading:false,
      finishLoading:false,
      cannelfinishLoading:false,
      orderstatus:0,
	  ischangerefundnum:false,
	  goodsLocationStatus:false,
	  batchStatus: false,
    }
  },

  filters: {
    /** 价格信息保留两位小数 **/
    CFMprice(value) {
	   return parseFloat(value).toFixed(2);

	   /**
       var price=parseFloat(value); //修剪去小数点后多余的0
       var numsobj=price.toString().split(".");	//判断小数点后有几位小数
	   var result=0.00;

       if(numsobj.length==1) result=price.toFixed(2); //值为0时补充到2位
       if(numsobj.length > 1 && numsobj[1].length <= 2) result=price.toFixed(2); //值为小数点后只有1位小数时补充到2位
       if(numsobj.length > 1 && numsobj[1].length > 2) result=price; //小数点后的值超出2位时直接返回
	   */
	   return result;		
    }
  },

  mounted(){
      this.getactionauth(); //获取权限设置
      this.getWarehouse(); //获取代理商仓库信息
      this.getAccount(); //获取支付方式信息
      this.getSeller(); //获取销售员
      this.getSupplier(); //获取供应商信息
      this.getBrand(); //获取商品品牌信息
      this.getCategoryList(); //获取产品分类信息
      
      this.getdocuments(); //获取订单编号
	  this.getLists();  //获取购物车商品信息
	  this.checkLocationStatus()
	  this.batchStatus = localStorage.getItem('batchStatus') == 'true'
  },
  methods:{
     
	/** 调整数字格式 **/
	changepriceformat(value) {
	   var price=parseFloat(value); //修剪去小数点后多余的0
       var numsobj=price.toString().split(".");	//判断小数点后有几位小数
	   var result=0.00;

       if(numsobj.length==1) result=price.toFixed(2); //值为0时补充到2位
       if(numsobj.length > 1 && numsobj[1].length <= 2) result=price.toFixed(2); //值为小数点后只有1位小数时补充到2位
       if(numsobj.length > 1 && numsobj[1].length > 2) result=price; //小数点后的值超出2位时直接返回
	   return result;	
	}, 

    
    /** 获取操作功能权限 **/
  	getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
    
    /** 获取仓库 **/
    getWarehouse(){
        var resource = this.$resource(this.GLOBAL.domain+"Ware/index");
        resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.wareHouseLists = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
          
        });
    },
    
    /** 获取银行帐户 **/
    getAccount(){
        var resource = this.$resource(this.GLOBAL.domain+"Account/index");
        resource.query({act:'lists',isnopay:1,token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.accountLists = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
          
        });
    },
    
    /** 获取销售员 **/
    getSeller(){
        var resource = this.$resource(this.GLOBAL.domain+"Clerk/index");
        resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.sellerLists = JSON.parse(Base64.decode(res.data.Data));                      
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    /** 获取供应商信息 **/
	getSupplier() {
	     var resource = this.$resource(this.GLOBAL.domain+"Product/index");
	     resource.query({act:'getapplyAll',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
		     if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		     }else{
		        this.supplierlists = JSON.parse(Base64.decode(res.data.Data));	                      
		     }
	     }).catch((res) => {
	            
	     });
	},
	
	/** 获取品牌 **/
    getBrand(){
        var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
        resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	        	var _this=this;
	            var result = JSON.parse(Base64.decode(res.data.Data));
	            this.brandlists=[];
	            result.forEach(function(e,i) {
	            	_this.brandlists.push({id:e.id,name:e.name,py:e.py,showlable:e.showlable});
	            });
	        }
        }).catch((res) => {
            
        });
    },
    
    /** 获取产品分类 **/
    getCategoryList() {
    	var resource = this.$resource(this.GLOBAL.domain+"Product/index");
        resource.query({ act:'getcatelist',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.categorylist=JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            
        });
    },
      
    /** 获取采购退货单信息 **/  
    getorderlists() {
    	this.orderLoading=true;
    	var resource = this.$resource(this.url);
        resource.save(this.order).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.orderLoading=false;
	        }else{
	            this.orderlists = JSON.parse(Base64.decode(res.data.Data));
	            this.order_total_rows=parseInt(res.data.count);
	            this.orderLoading=false;
	        }
        }).catch((res) => {
            this.orderLoading=false;
        });
    },
    
    orderPageSizeChange(val) {
        this.order.rollpage = val;
        this.getorderlists();
    },
    orderPageCurrentChange(val) {
        this.order.p = val;
        this.getorderlists();
    },
    
    
    //新增退货单
    add() {
    	this.$emit('listenchild',{name:'新增采购退货单',url:'Purcharorderadd'});
    	return false;
    
      	this.create.id=0;
      	this.create.applyid='';
      	this.create.clerkid='';
      	this.create.documents='';
      	this.create.account='';
      	this.create.total=0.00;
      	this.create.real=0.00;
      	this.create.derate=0.00;
      	this.create.note='';
      	this.create.goods=[];
    
		this.addDialog=true;
		this.getLists();  //获取购物车商品信息
		this.getdocuments(); //获取订单编号
    },
    
    //获取订单编号
    getdocuments() {
    	var resource = this.$resource(this.url);
        resource.save({act:'getdocuments',token:this.$cookies.get('token'),createid:this.create.id}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            var result = JSON.parse(Base64.decode(res.data.Data));
	            this.create.documents=result.documents;         
	        }
        }).catch((res) => {

        });
    },
    
    //获取退货商品信息
    getLists() {
    	this.goodsListLoading=true;
    	var resource = this.$resource(this.url);
        resource.save({act:'gettempgoods_news',token:this.$cookies.get('token'),createid:this.create.id}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.goodsListLoading=false;
	        }else{
	            this.create.goods = JSON.parse(Base64.decode(res.data.Data));
	            this.goodsListLoading=false;
	            
	            //计算订单金额、应付金额	            
	            var _this=this;
	            var total=0;
	            var real=0;
				this.create.derate=this.changepriceformat(this.create.derate);
	            this.create.goods.forEach(function(e,index) {
					e.buy=_this.changepriceformat(e.buy);
					e.total=_this.changepriceformat(e.total);
					total += parseFloat(e.total);
				});
	            real=this.changepriceformat(total-this.create.derate);
	            this.create.total=this.changepriceformat(total);
	            this.create.real=this.changepriceformat(real);  
				
				console.log(this.create.goods, 'PPPPPPPPPPPPPPPPPPPPPPPPP');
	        }
        }).catch((res) => {
            this.goodsListLoading=false;
        });
    },
    
    //统计合计信息
    totalRule() {
    	var _this=this;
	    var price=0;
	    var num=0;
	    var total=0;	    		    	
	    this.create.goods.forEach(function(e,index) {
			price += parseFloat(e.buy);
			num += parseInt(e.basenum);
			total += parseFloat(e.total);
		});

		price=price.toFixed(2);
		total=total.toFixed(2);
		if(this.goodsLocationStatus){
			return ['合计','','','',num,total,'',''];
		}else{
			return ['合计','','','',num,total,''];
		}
    },
    
    //批量添加退货商品
    addDialogmore() {    
      	this.productquery.key='';
      	this.productquery.brandid='';
      	this.productquery.catid=[];
      	this.productquery.warehouse=[];
      	this.productquery.clerkid=this.create.clerkid;
      	this.productquery.applyid=this.create.applyid;   
      	this.productselect=true;  
    	this.addproductDialog=true;
    	this.multipleSelection=[];
      	this.getProductList();
    },
    
    //点击搜索商品信息
    addDialogShow() {
      	this.productquery.brandid='';
      	this.productquery.catid=[];
      	this.productquery.warehouse=[];
      	this.productquery.clerkid=this.create.clerkid;
      	this.productquery.applyid=this.create.applyid;   
      	this.productselect=true;  
    	this.addproductDialog=true;
    	this.multipleSelection=[];
      	this.getProductList();
    },
    
    //点击回车按关键字搜索商品，只有一个的直接添加，两个以上的展开列表
    addDialogsingle() {
    	this.productquery.brandid='';
      	this.productquery.catid=[];
      	this.productquery.warehouse=[];
      	this.productquery.clerkid=this.create.clerkid;
      	this.productquery.applyid=this.create.applyid;   
      	this.productselect=true;  
    	this.multipleSelection=[];
    
    	var resource = this.$resource(this.url);
        resource.save({act:'sweep',token:this.$cookies.get('token'),applyid:this.create.applyid,clerkid:this.create.clerkid,key:this.productquery.key}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            var result = JSON.parse(Base64.decode(res.data.Data));
				if(result.num==1) {this.multipleSelection.push(result.productid);this.addSave();} //当商品信息只有一个时直接添加进入购物车
				if(result.num > 1) {this.addproductDialog=true;this.getProductList();} //当商品信息有2个以上时弹出选择列表
				 
	        }
        }).catch((res) => {
            
        });
    },
    
    selectbrand() {
    	this.productselect=true;
    	this.getProductList();
    },
    
    selectcate() {
    	this.productselect=true;
    	this.getProductList();
    },
    
    changesearchkey() {
    	this.productselect=true;
    	this.getProductList();
    },
    
    //获取需要添加的商品信息
    getProductList() {
    	if(this.productselect==true) {
    		this.productquery.p=1;
    		this.productquery.rollpage=10;
    	}

    	this.addListLoading=true;
    	var resource = this.$resource(this.url);
        resource.save(this.productquery).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.addListLoading=false;
	        }else{
	            this.productlists = JSON.parse(Base64.decode(res.data.Data));
	            this.total_product_rows=parseInt(res.data.count);
	            this.addListLoading=false;
	            if(this.productselect==true) this.productselect=false;
	            
	            //已选的商品予以勾选
				var _this=this;
				var number=-1;
				setTimeout(function() {
					_this.productlists.forEach(function(item,index) {
						number=-1;
						_this.multipleSelection.forEach(function(tt,index) {
							if(item.detailid==tt.detailid) {
								number=index;
								item.refundnums=tt.refundnums;
							}
						});
						number >=0 ? _this.$refs.multipleTable.toggleRowSelection(item) : '';
		        	});
				},200);
		        
	            
	        }
        }).catch((res) => {
            this.addListLoading=false;
        });
    },
    
	productPageSizeChange(val) {
        this.productquery.rollpage = val;
        this.getProductList();
    },
    productPageCurrentChange(val) {
        this.productquery.p = val;
        this.getProductList();
    },
    
    
	///////////////////////////////////////////////////////
	//商品选择点击事件交互

	//单行点击获取采购退货商品信息
	rowclick(row,val) {
		if(this.ischangerefundnum) return false;
		this.changesingle(row,val,1);
	},

	//单选退货商品信息
	handleSelectsingle(val,row) {
		this.changesingle(row,val,2);
	},

	//修改保存商品信息
	changesingle(row,val,ischange) {
		if(ischange==1) this.$refs.multipleTable.toggleRowSelection(row);
		var number=-1;
		var _this=this;

		this.multipleSelection.forEach(function(item,index) {
			if(item.detailid==row.detailid) number=index;
		});
		number >=0 ? 
		this.$delete(this.multipleSelection,number) :
		this.multipleSelection.push(row);
	},

	//全选 / 全不选
	handleSelectall(val) {
		var _this=this;
		var number=-1;
		if(val.length > 0) { //全选

			val.forEach(function(item,index) {
				number=-1;
				_this.multipleSelection.forEach(function(tt,ii) {
					if(item.detailid==tt.detailid) number=index;
				});
				number==-1 ? 
				_this.multipleSelection.push(item) : '';
			});		

		}else { //全不选

			this.productlists.forEach(function(item,index) {
				number=-1;
				_this.multipleSelection.forEach(function(tt,ii) {
					if(item.detailid==tt.detailid) number=index;
				});
				number >= 0 ? 
				_this.$delete(_this.multipleSelection,number) : '';
			});		
		}
	},

	focusrefundnums() {
		this.ischangerefundnum=true;
	},

	//判断数据修改是否正确
	blurrefunnums(item) {
		if(item.refundnums > item.inventory) {
			item.refundnums=1;
			var number=-1;
			var _this=this;

			//同步修改已选中的商品
			_this.multipleSelection.forEach(function(tt,ii) {
				if(item.detailid==tt.detailid) number=ii;
			});
			number >=0 ? this.multipleSelection[number].refundnums=item.refundnums : '';

			this.$message.error('退货数量不能大于可退数量');
			return false;

		}else {
			var number=-1;
			var _this=this;

			//同步修改已选中的商品
			this.multipleSelection.forEach(function(tt,ii) {
				if(item.detailid==tt.detailid) number=ii;
			});
			number >=0 ? this.multipleSelection[number].refundnums=item.refundnums : '';

		}

		this.ischangerefundnum=false;
	},

	//商品选择点击事件交互
	//////////////////////////////////////////////////////



    
    /** 清空选中的商品信息 **/
    cleargoods() {
    	var _this=this;
    	this.productlists.forEach(function(e,index) {
    		_this.multipleSelection.indexOf(e.id)!= -1 ? _this.$refs.multipleTable.toggleRowSelection(e) : "";
		});
    	this.multipleSelection=[];
    },
    
    /** 确认添加商品进入购物车 **/
    addSave() {
    	this.addProductLoading=true;
    	if(this.multipleSelection.length==0) {
			this.addProductLoading=false;
			this.$message.error('请选择需要退货的商品');
			return false;
		}

		var data=[];
		this.multipleSelection.forEach(function(item,index) {data.push(item)});

    	var resource = this.$resource(this.url);
        resource.save({act:'addcart_news',token:this.$cookies.get('token'),data:JSON.stringify(data),createid:this.create.id,applyid:this.create.applyid,clerkid:this.create.clerkid}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.addProductLoading=false;
	        }else{
	            this.$message.success('新增成功');
	            this.addProductLoading=false;
	            this.addproductDialog=false;
	            this.getLists();
	        }
        }).catch((res) => {
			this.addProductLoading=false;
        });
    },
    
    /** 复制当前商品信息进入购物车 **/
    copygoods(item) {
    	this.multipleSelection=[];
    	this.multipleSelection.push(item.productid);
    	this.addSave();
    },
    
    /** 删除当前购物车里的商品信息 **/
    delgoods(item) {
    	this.$confirm('您是否需要删除该商品信息？', '提示', { type: 'warning' }).then(() => {
        		// 向请求服务端删除
	            var resource = this.$resource(this.url);
	            resource.save({ act:'deltempgoods',id:item.id,token:this.$cookies.get('token')}).then((res) => {
	            	if(res.data.Result>0){
	                    if(res.data.Result=='70001') this.$router.push('/login')
	                    this.$message.error(res.data.Message);
	                }else{
	                    this.$message.success('删除商品信息成功！');
	                    this.getLists();
	                }
	            }).catch((res) => {
	            	
	            });
	    }).catch(() => {
	            
	    });
    },
    
    //修改优惠金额
    changederate() {
    	if(this.create.derate<0) {this.$message.error("优惠金额不能为负数");this.create.derate=0;this.getLists();return false;}
    	if(isNaN(this.create.derate)) {this.$message.error("请输入正确的优惠金额");this.create.derate=0;this.getLists();return false;}
    	if(parseFloat(this.create.total)<parseFloat(this.create.derate)) {this.$message.error("订单总额不能小于优惠金额");this.create.derate=0;this.getLists();return false;}
    	var real=parseFloat(this.create.total)-parseFloat(this.create.derate);
    	this.create.real=real.toFixed(2);
    },
    
    //修改订单应付金额
    changereal() {
    	if(this.create.real<0) {this.$message.error("应付金额不能为负数");this.create.derate=0;this.getLists();return false;}
    	if(isNaN(this.create.real)) {this.$message.error("请输入正确的应付金额");this.create.derate=0;this.getLists();return false;}
    	if(parseFloat(this.create.total)<parseFloat(this.create.real)) {this.$message.error("订单总额不能小于应付金额");this.create.derate=0;this.getLists();return false;}
    	var derate=parseFloat(this.create.total)-parseFloat(this.create.real);
    	this.create.derate=derate.toFixed(2);
    },
    
    //获取商品单位信息
    getUnitlists(item) {
    	this.unitDialog=true;
    	this.unitListLoading=true;
    	this.unitlists.tempid=item.id;
    	
    	var resource = this.$resource(this.url);
	    resource.save({ act:'getUnitlists',token:this.$cookies.get('token'),productid:item.productid}).then((res) => {
	    	if(res.data.Result>0){
	        	if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.unitListLoading=false;
	        }else{
	        	this.unitlists.lists = JSON.parse(Base64.decode(res.data.Data));
	            this.unitListLoading=false;
	        }
	    }).catch((res) => {
	       this.unitListLoading=false; 	
	    });
    },
    
    //保存修改的单位信息
    changeUnitSave(item) {
    	var resource = this.$resource(this.url);
	    resource.save({ act:'saveunits',token:this.$cookies.get('token'),tempid:this.unitlists.tempid,id:item.id,applyid:this.create.applyid,clerkid:this.create.clerkid}).then((res) => {
	    	if(res.data.Result>0){
	        	if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.unitDialog=false;
	            this.getLists();
	        }else{
	        	this.$message.success("修改成功！");
	            this.unitDialog=false;
	            this.getLists();
	        }
	    }).catch((res) => {
	       this.unitDialog=false; 	
	    });
    },
    
    //修改成本价
    setgoodsbuy(item) {
    	var resource = this.$resource(this.url);
	    resource.save({ act:'changebuy',token:this.$cookies.get('token'),tempid:item.id,buy:item.buy}).then((res) => {
	    	if(res.data.Result>0){
	        	if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.getLists();
	        }else{
	        	this.$message.success("修改成功！");
	            this.getLists();
	        }
	    }).catch((res) => {
	
	    });
    },
    
    //修改数量信息
    setgoodsnum(item) {
    	var resource = this.$resource(this.url);
	    resource.save({ act:'changenums_news',token:this.$cookies.get('token'),tempid:item.id,num:item.basenum,applyid:this.create.applyid,clerkid:this.create.clerkid}).then((res) => {
	    	if(res.data.Result>0){
	        	if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.getLists();
	        }else{
	        	this.$message.success("修改成功！");
	            this.getLists();
	        }
	    }).catch((res) => {
	
	    });
    },
    
    //获取仓库信息
    changewarehouse(item) {
    	this.wareDialog=true;
    	this.wareListLoading=true;
    	this.warehouselists.tempid=item.id;
    	
    	var resource = this.$resource(this.url);
	    resource.save({ act:'getwarelists',token:this.$cookies.get('token')}).then((res) => {
	    	if(res.data.Result>0){
	        	if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.wareListLoading=false;
	        }else{
	        	this.warehouselists.lists = JSON.parse(Base64.decode(res.data.Data));
	            this.wareListLoading=false;
	        }
	    }).catch((res) => {
	       this.wareListLoading=false; 	
	    });
    },
    
    //保存修改的仓库信息
    changewarehouseSave(item) {
    	var resource = this.$resource(this.url);
	    resource.save({ act:'savewarehouse',token:this.$cookies.get('token'),tempid:this.warehouselists.tempid,id:item.id,applyid:this.create.applyid,clerkid:this.create.clerkid}).then((res) => {
	    	if(res.data.Result>0){
	        	if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.wareDialog=false;
	            this.getLists();
	        }else{
	        	this.$message.success("修改成功！");
	            this.wareDialog=false;
	            this.getLists();
	        }
	    }).catch((res) => {
	       this.wareDialog=false; 	
	    });
    },
    
    //修改小计金额
    setgoodstotal(item) {
    	var resource = this.$resource(this.url);
	    resource.save({ act:'changetotal',token:this.$cookies.get('token'),tempid:item.id,total:item.total}).then((res) => {
	    	if(res.data.Result>0){
	        	if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.getLists();
	        }else{
	        	this.$message.success("修改成功！");
	            this.getLists();
	        }
	    }).catch((res) => {
	
	    });
    },
    
    //关闭当前窗口询问是否需要清除数据
    handleDialogClose() {
    	var isdel=0;
    	if(this.create.id>0 && this.create.goods.length > 0) {
    		var resource = this.$resource(this.url);
		    resource.save({ act:'deltemps',token:this.$cookies.get('token'),createid:this.create.id}).then((res) => {
		    	if(res.data.Result>0){
		        	if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		        }
		    }).catch((res) => {
		
		    });
    		
    	}else if(this.create.id==0 && this.create.goods.length >0) {
    		this.$confirm('您是否需要保存退货商品信息？', '提示', { type: 'warning' }).then(() => {
	        	var resource = this.$resource(this.url);
			    resource.save({ act:'deltemps',token:this.$cookies.get('token'),createid:this.create.id}).then((res) => {
			    	if(res.data.Result>0){
			        	if(res.data.Result=='70001') this.$router.push('/login')
			            this.$message.error(res.data.Message);
			        }
			    }).catch((res) => {
			
			    });
		    }).catch(() => {
		            
		    });
    	}
    },
    
    //删除购物车里的全部商品信息
    clearall() {
    	this.$confirm('您是否需要清空全部商品信息？', '提示', { type: 'warning' }).then(() => {
	        var resource = this.$resource(this.url);
			resource.save({ act:'deltemps',token:this.$cookies.get('token'),createid:this.create.id}).then((res) => {
			    if(res.data.Result>0){
			        if(res.data.Result=='70001') this.$router.push('/login')
			        this.$message.error(res.data.Message);
			    }else {
			    	this.$message.success("清空商品成功！");
			    	this.getLists();
			    }
			}).catch((res) => {
			
			});
		}).catch(() => {
		            
		});
    },
    
    //删除当前订单信息
    delSave() {
    	this.$confirm('您是否需要删除当前的订单信息？', '提示', { type: 'warning' }).then(() => {
    		this.delorderLoading=true;
	        var resource = this.$resource(this.url);
			resource.save({ act:'delorder',token:this.$cookies.get('token'),id:this.create.id}).then((res) => {
			    if(res.data.Result>0){
			        if(res.data.Result=='70001') this.$router.push('/login')
			        this.delorderLoading=false;
			        this.$message.error(res.data.Message);
			    }else {
			    	this.$message.success("删除订单成功！");
			    	//this.addDialog=false;
			    	this.getorderlists();
			    }
			}).catch((res) => {
			
			});
		}).catch(() => {
		            
		});
    },
    
    //删除列表页里的订单信息
    delCurrent(item) {
    	this.$confirm('您是否需要删除当前的订单信息？', '提示', { type: 'warning' }).then(() => {
	        var resource = this.$resource(this.url);
			resource.save({ act:'delorder',token:this.$cookies.get('token'),id:item.id}).then((res) => {
			    if(res.data.Result>0){
			        if(res.data.Result=='70001') this.$router.push('/login')
			        this.$message.error(res.data.Message);
			    }else {
			    	this.$message.success("删除订单成功！");
			    	this.getorderlists();
			    }
			}).catch((res) => {
			
			});
		}).catch(() => {
		            
		});
    },
    
    //保存当前的订单信息
    createSave() {
    	this.create.act="saveorder_news";
    	this.addorderLoading=true;
	    var resource = this.$resource(this.url);
		resource.save(this.create).then((res) => {
			if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.addorderLoading=false;
			    this.$message.error(res.data.Message);
			}else {
			    this.$message.success("保存订单成功！");
			    this.addorderLoading=false;

	      	    this.create.id=0;
	      	    this.create.applyid='';
	      	    this.create.clerkid='';
	      	    this.create.documents='';
	      	    this.create.account='';
	      	    this.create.total=0.00;
	      	    this.create.real=0.00;
	      	    this.create.derate=0.00;
	      	    this.create.note='';			    
			    this.create.goods=[];
			    
			    this.getdocuments(); //获取订单编号
			    this.getLists();  //获取购物车商品信息
			    return false;
			}
		}).catch((res) => {
			
		});
    },
    
    //审核当前的订单信息
    verifySave() {
    	this.create.act="verifySave_news";
    	this.verifyorderLoading=true;
	    var resource = this.$resource(this.url);
		resource.save(this.create).then((res) => {
			if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.verifyorderLoading=false;
			    this.$message.error(res.data.Message);
			}else {
			    this.$message.success("审核订单成功！");
			    this.verifyorderLoading=false;
			    this.create.id=0;
	      	    this.create.applyid='';
	      	    this.create.clerkid='';
	      	    this.create.documents='';
	      	    this.create.account='';
	      	    this.create.total=0.00;
	      	    this.create.real=0.00;
	      	    this.create.derate=0.00;
	      	    this.create.note='';			    
			    this.create.goods=[];
			    this.create.goods=[];
			    this.getdocuments(); //获取订单编号
	  			this.getLists();  //获取购物车商品信息
			}
		}).catch((res) => {
			
		});
    },
    
    //确认审核并打印
    verifyandprintSave() {
    	this.create.act="verifySave_news";
    	this.verifyandprintorderLoading=true;
    	var resource = this.$resource(this.url);
		resource.save(this.create).then((res) => {
			if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.verifyandprintorderLoading=false;
			    this.$message.error(res.data.Message);
			}else {
			    this.$message.success("审核订单成功！");
			    var result = JSON.parse(Base64.decode(res.data.Data));
			    this.verifyandprintorderLoading=false;
			    this.create.id=0;
	      	    this.create.applyid='';
	      	    this.create.clerkid='';
	      	    this.create.documents='';
	      	    this.create.account='';
	      	    this.create.total=0.00;
	      	    this.create.real=0.00;
	      	    this.create.derate=0.00;
	      	    this.create.note='';			    
			    this.create.goods=[];
			    this.create.goods=[];
			    this.getdocuments(); //获取订单编号
	  			this.getLists();  //获取购物车商品信息
			    
			    this.getprintdetail(result.id); //打印订单
			}
		}).catch((res) => {
			
		});

    },
    
    //编辑商品信息
    editorder(item) {
		// 如果没有id直接关掉这个页面
		if(!item.id) {
			this.$emit('closechild','Purcharrefundedit'); //关闭窗口
		}
    	var resource = this.$resource(this.url);
		resource.save({ act:'editorder',token:this.$cookies.get('token'),id:item.id}).then((res) => {
			if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.$message.error(res.data.Message);
			}else {
			    var result = JSON.parse(Base64.decode(res.data.Data));
      	  		this.create.id=item.id;
		      	this.create.applyid=result.applyid;
		      	this.create.clerkid=result.clerkid;
		      	this.create.documents=result.documents;
		      	this.create.account=result.account;
		      	this.create.derate=result.derate;
		      	this.create.note=result.note,
		      	this.create.goods=[],
			    this.addDialog=true;
			    this.getLists();
			}
		}).catch((res) => {
			
		});
    },
    
    showorder(item) {
    	this.getprintdetail(item.id);
    },
    
    //获取订单打印信息
    getprintdetail(id) {
    	this.printLoading=true;
		this.printerDialog=true;
		this.printlists=[];
		var resource = this.$resource(this.url);
		resource.save({act:'getprintinfos',token:this.$cookies.get('token'),id:id,rollpage:this.rollpage}).then((res) => {
		    if(res.data.Result>0){
		    	if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		        this.printLoading=false;
		    }else{
		    	this.printLoading=false;
		        this.printlists=JSON.parse(Base64.decode(res.data.Data));
		        this.orderstatus=this.printlists[0].status;
		    }
		}).catch((res) => {
			this.printLoading=false;
		});  
    },
    
    //修改订单打印每页展示条数
	changepagevlaue() {
	    this.getprintdetail(this.printlists[0].id);
	},
    
    //打印订单
    createnoSave() {
    	var id=this.printlists[0].id;
	    this.printorderLoading=true;
	    var resource = this.$resource(this.url);
		resource.save({act:'changeprintnumber',token:this.$cookies.get('token'),id:id}).then((res) => {
		    if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		        this.printorderLoading=false;
		    }else{
		        this.printorderLoading=false;
		        this.printlocalpage(); //打印 
		    }
		}).catch((res) => {
			this.printorderLoading=false;
		});
    },
    
    /** 打印当前页面 **/
	printlocalpage() {
	    //设置打印信息
	    var div_print=document.getElementById('printContent');
		var newStr=div_print.innerHTML;
		var oldStr=document.body.innerHTML;
		document.body.innerHTML=newStr;
		window.print();
		document.body.innerHTML=oldStr;	    
		location.reload();
	},
	
	/** 撤销审核 **/
    cannelverify() {
    	this.cannelLoading=true;
    	this.$confirm('您是否确定要撤销该订单信息的审核？', '提示', { type: 'warning' }).then(() => {
	        var resource = this.$resource(this.url);
			resource.save({ act:'cannelverify',token:this.$cookies.get('token'),id:this.printlists[0].id}).then((res) => {
			    if(res.data.Result>0){
			        if(res.data.Result=='70001') this.$router.push('/login')
			        this.$message.error(res.data.Message);
			        this.cannelLoading=false;
			    }else {
			    	this.$message.success("订单撤销审核成功！");
			    	this.printerDialog=false;
			    	this.cannelLoading=false;
			    	this.getorderlists(); //刷新订单列表
			    }
			}).catch((res) => {
			
			});
		}).catch(() => {
		    this.cannelLoading=false;        
		});
    },
    
    /** 完成订单 **/
    finishorder() {
    	this.finishLoading=true;
    	this.$confirm('您是否确定要完成该订单？', '提示', { type: 'warning' }).then(() => {
	        var resource = this.$resource(this.url);
			resource.save({ act:'finishorder',token:this.$cookies.get('token'),id:this.printlists[0].id}).then((res) => {
			    if(res.data.Result>0){
			        if(res.data.Result=='70001') this.$router.push('/login')
			        this.$message.error(res.data.Message);
			        this.finishLoading=false;
			    }else {
			    	this.$message.success("订单撤销审核成功！");
			    	this.printerDialog=false;
			    	this.finishLoading=false;
			    	this.getorderlists(); //刷新订单列表
			    }
			}).catch((res) => {
			
			});
		}).catch(() => {
		    this.finishLoading=false;        
		});
    },
    
    
    /** 撤销已完成订单 **/
    cannelfinish() {
    	this.cannelfinishLoading=true;
    	this.$confirm('您是否确定要将该订单的状态修改成已审核？', '提示', { type: 'warning' }).then(() => {
	        var resource = this.$resource(this.url);
			resource.save({ act:'cannelfinish',token:this.$cookies.get('token'),id:this.printlists[0].id}).then((res) => {
			    if(res.data.Result>0){
			        if(res.data.Result=='70001') this.$router.push('/login')
			        this.$message.error(res.data.Message);
			        this.cannelfinishLoading=false;
			    }else {
			    	this.$message.success("订单撤销审核成功！");
			    	this.printerDialog=false;
			    	this.cannelfinishLoading=false;
			    	this.getorderlists(); //刷新订单列表
			    }
			}).catch((res) => {
			
			});
		}).catch(() => {
		    this.cannelfinishLoading=false;        
		});
    },
    
    
    //改变供应商检测商品信息
    changesupplier() {
	    var resource = this.$resource(this.url);
		resource.save({act:'changeapplyorseller',token:this.$cookies.get('token'),applyid:this.create.applyid,clerkid:this.create.clerkid}).then((res) => {
		    if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		        this.create.applyid='';
      			this.create.clerkid='';
		    }else{
		        
		    }
		}).catch((res) => {
			this.create.applyid='';
      		this.create.clerkid='';
		});
    },
	checkLocationStatus(){
      const goodsLocationStatus = localStorage.getItem("storageLocationStatus")||''
      if(goodsLocationStatus == "true"){
        this.goodsLocationStatus=true
      }else{
        this.goodsLocationStatus=false
      }      
    },
    
  }
}
</script>

<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}

.cz-sell-base-lists-infos-out {display:inline-block;width:100%;}
.cz-sell-base-lists-infos {float:left;display:flex;justify-content:left;align-items:center;font-size:0;width:25%;height:50px;overflow:hidden;}
.cz-sell-base-lists-infos .cz-sell-base-lists-infos-title {float:left;text-align:right;font-size:13px;line-height:23px;}
.cz-sell-base-lists-infos .cz-sell-base-lists-infos-content {float:left;margin-left:10px;}
.cz-sell-base-lists-infos .cz-sell-base-lists-infos-content .el-input__inner {text-align:left;width:220px;border-bottom:1px solid #dcdfe6;border-top:none;border-left:none;border-right:none;border-radius:0;height:40px;line-height:40px;font-size:13px;}
.cz-sell-base-lists-infos .cz-sell-base-lists-infos-content .el-input__inner:hover {box-shadow:none;border-bottom:1px solid #dcdfe6;}
.cz-sell-base-lists-infos .el-input.is-active .el-input__inner, .cz-sell-base-lists-infos .el-input__inner:focus {border-color:#dcdfe6 !important;}
.cz-sell-base-lists-infos .cz-sell-base-lists-infos-content .el-checkbox__inner {margin-top:7px}

.cz-sell-base-lists-infos-goods {display:inline-block;width:100%;margin-top:20px;}
.cz-sell-base-lists-infos-goods .el-table {font-size:13px;}
.cz-sell-base-lists-infos-goods .el-table th.is-leaf {background:#E4E7ED;}
.cz-sell-base-lists-infos-goods .el-table td, .cz-sell-base-lists-infos-goods .el-table th.is-leaf {border-bottom:1px solid #E4E7ED;}
.cz-sell-base-lists-infos-goods .el-table .el-table_body tr,.cz-sell-base-lists-infos-goods .el-table .hover-row > td {background-color:#E4E7ED;}
.cz-sell-base-lists-infos-goods .el-table__fixed-footer-wrapper tbody td {background:#E4E7ED;border-bottom:1px solid #E4E7ED;}
.cz-sell-base-lists-infos-goods .el-input__inner {overflow:hidden;text-overflow:ellipsis;white-space:nowrap;text-align:center;border-bottom:none;border-top:none;border-left:none;border-right:none;border-radius:15px;height:32px;line-height:32px;font-size:13px;}
.cz-sell-base-lists-infos-goods .el-input__inner:hover {box-shadow:none;border:none;}
.cz-sell-base-lists-infos-goods .el-table__footer-wrapper tbody td, .cz-sell-base-lists-infos-goods .el-table__header-wrapper tbody td {background-color:#E4E7ED;}
.cz-sell-base-lists-infos-goods .el-table--enable-row-hover .el-table__body tr:hover>td {background-color:#E4E7ED;}
.cz-table-refund-num-style1 .el-input__inner {border:1px solid #dcdfe6;border-radius:15px 0 0 15px;}

.cz-sell-order-stat {width:calc(100%);height:100px;position:relative;margin-top:10px;margin-bottom:20px;background:none;display:flex;justify-content:center;align-items:center;}
.cz-sell-order-stat-handles {padding:10px 20px;height:60px;border-left:1px solid #EBEEF5;width:30%;display:flex;justify-content:left;align-items:center;overflow:hidden;}
.cz-sell-order-stat-totals {padding:10px 20px;height:100px;width:calc(100% - 30% - 40px - 40px - 1px);display:flex;justify-content:left;align-items:center;overflow:hidden;}
.cz-sell-order-stat-totals-name {float:left;width:calc(25% - 30px) !important;padding:3px 30px 0 0 !important;font-size:13px;}
.cz-sell-order-stat-totals-name-title {float:left;width:80px;}
.cz-sell-order-stat-totals-name-content {float:left;width:calc(100% - 100px - 10px - 30px);padding:0 15px;color:red;font-weight:550;font-size:14px;}

.cz-sell-order-stat-totals-name .el-input {width:calc(100% - 80px - 5px);font-size:14px;}
.cz-sell-order-stat-totals-name .el-input__inner {color:red;font-weight:550;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;text-align:center;border-bottom:1px solid #c0c4cc !important;border-top:none;border-left:none;border-right:none;border-radius:0;height:32px;line-height:32px;font-size:13px;background:none;text-align:left;}
.cz-sell-order-stat-totals-name .el-input__inner:hover {box-shadow:none;border:none;border-bottom:1px solid #c0c4cc !important;background:none;}
.cz-sell-order-stat-totals-name .el-input.is-active .el-input__inner, .cz-sell-order-stat-totals-name .el-input__inner:focus {border-color:#c0c4cc !important;background:none;}


</style>


// WEBPACK FOOTER //
// src/components/purchase/Purcharrefundadd.vue